import React from 'react';
import { GridLayout } from '@uswitch/ev-core/react';
import { getValue } from './utils';
import { ButtonLink } from '../../elements/button-link';
import { TruTick } from '@uswitch/spark-icons/tru';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var Row = GridLayout.Row,
    Column = GridLayout.Column;

var EligibilityInformation = function EligibilityInformation(_ref) {
  var content = _ref.content,
      data = _ref.data,
      headerImage = _ref.headerImage,
      onClick = _ref.onClick;

  var formatValue = function formatValue(value) {
    if (value === true || value === 'Yes' || value === 'yes' || value === 'true') {
      if (headerImage) {
        return _jsxs(React.Fragment, {
          children: [_jsx("div", {
            sx: {
              variant: "elements.eligibility-criteria.variants.redesign.item.value.icon"
            },
            children: _jsx(TruTick, {
              color: '#6bab51',
              size: 18
            })
          }), _jsx("div", {
            sx: {
              variant: "elements.eligibility-criteria.variants.redesign.item.value.text"
            },
            children: "Yes"
          })]
        });
      }

      return 'Yes';
    }

    if (value === false) return 'No';
    return value;
  };

  var renderList = function renderList(section) {
    return section.type === 'additional' ? _jsx("ul", {
      sx: {
        variant: 'elements.eligibility-criteria.item.additional'
      },
      children: section.list.map(function (item, key) {
        return _jsx("li", {
          children: getValue(item.value, data)
        }, key);
      }, this)
    }) : section.type === 'cta' ? _jsx(ButtonLink, {
      onClick: onClick,
      variant: "primary",
      href: getValue(section.primary.href, data),
      target: "_blank",
      sx: {
        variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "item.cta")
      },
      children: getValue(section.primary.text, data)
    }) : section.list.map(function (item, key) {
      return item.icon ? _jsxs("div", {
        sx: {
          display: 'flex',
          alignItems: 'center'
        },
        children: [_jsx(TruTick, {
          color: '#6bab51',
          size: 18,
          sx: {
            mt: '0',
            mr: 'md'
          }
        }), _jsx("span", {
          sx: {
            variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "item.title")
          },
          children: item.label
        }), _jsx("span", {
          sx: {
            variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "item.value")
          },
          children: "".concat(getValue(item.value, data))
        })]
      }) : _jsxs("div", {
        sx: {
          variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "item.base")
        },
        children: [_jsx("span", {
          sx: {
            variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "item.title")
          },
          children: item.label
        }), _jsx("span", {
          sx: {
            variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "item.value")
          },
          children: formatValue(getValue(item.value, data))
        })]
      });
    }, this);
  };

  return _jsx(Row, {
    sx: {
      margin: 0
    },
    children: content.map(function (section, index) {
      return _jsx(Column, {
        s: 1 / 1,
        m: 4 / 12,
        l: 4 / 12,
        sx: {
          paddingBottom: headerImage ? [0, 'lg'] : 'lg',
          paddingX: ['sm', '12px'],
          paddingTop: [0, '1px'],
          '&:first-of-type': {
            paddingLeft: ['sm', 'lg'],
            paddingTop: '1px'
          },
          '&:last-child': {
            paddingRight: ['sm', 'lg']
          }
        },
        children: _jsxs("div", {
          sx: {
            variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "base"),
            display: section.type === 'cta' && ['block', 'none']
          },
          children: [_jsx("span", {
            sx: {
              variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "title")
            },
            children: getValue(section.title)
          }), section.subtitle ? _jsx("span", {
            sx: {
              variant: 'elements.eligibility-criteria.subtitle'
            },
            children: getValue(section.subtitle)
          }) : null, section.label ? _jsx("span", {
            sx: {
              mb: section.type === 'additional' ? 'sm' : 'md',
              variant: "elements.eligibility-criteria.".concat(headerImage && 'variants.redesign.', "label")
            },
            children: getValue(section.label)
          }) : null, renderList(section), section.subscript ? _jsx("span", {
            sx: {
              variant: 'elements.eligibility-criteria.subscript'
            },
            children: getValue(section.subscript)
          }) : null]
        })
      });
    }, this)
  });
};

export default EligibilityInformation;
//# sourceMappingURL=eligibility-information.js.map